export default {
  "home.heading.default": "залетай в звонок",
  "home.heading.loading": "открываем комнату...",
  "home.heading.join": "готов зайти?",
  "home.heading.joined": "ты в комнате",
  "home.heading.pending": "ждем хоста",
  "home.body.default": "создай комнату, кинь ссылку, кайфуй.",
  "home.body.loading": "секунду, грузим комнату.",
  "home.body.join": "чекни камеру и микро, и залетай.",
  "home.body.joined": "комната готова. кидай ссылку или просто начинай.",
  "home.body.joined_in_room": "ты в комнате — кидай ссылку или начинай.",
  "home.body.pending": "комната закрыта. хост скоро впустит.",
  "home.cta.create": "Создать комнату",
  "home.cta.join": "Войти в комнату",
  "home.cta.enter": "Зайти",
  "home.cta.creating": "Создаем...",
  "home.cta.joining": "Заходим...",
  "home.cta.opening": "Открываем...",
  "home.cta.pending": "Ждем аппрува...",
  "home.copy_link": "скопировать ссылку",
  "home.copied": "скопировано!",
  "home.leave": "выйти из комнаты",
  "home.back": "назад",
  "home.no_participants": "тут пока никого",
  "home.join_by_code": "войти по коду",
  "home.code_placeholder": "введи код",
  "home.name_placeholder": "твое имя",
  "home.people_one": "человек",
  "home.people_other": "человек",
  "home.marketing.invite.title": "Создай комнату,\nподелись ссылкой.",
  "home.marketing.invite.body": "В один клик. Кинь ссылку друзьям, и они смогут зайти — без скачиваний и регистраций.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Выгляди\nкак хочешь.",
  "home.marketing.look.body": "Цветокор, софт-фокус, виньетка — или вообще заблюрь лицо. Твоя камера, твой стиль.",
  "home.marketing.host.title": "Твое пространство,\nтвои правила.",
  "home.marketing.host.body": "Закрой комнату, замьють кого-то или вообще кикни. Хост решает.",
  "home.marketing.host.locked": "Комната закрыта",
  "home.marketing.host.waiting_to_join": "Ждут входа",
  "home.marketing.host.wants_to_join": "хочет зайти",
  "home.marketing.anything.title": "Вообще для всего.",
  "home.marketing.anything.body": "Ботать вместе, играть, рабочие стендапы, смотреть видосы — или просто чиллить.",
  "home.marketing.use_case.study_group": "📚 стади-группа",
  "home.marketing.use_case.game_night": "🎮 поиграть",
  "home.marketing.use_case.standup": "💼 стендап",
  "home.marketing.use_case.watch_party": "🍿 вотч-пати",
  "home.marketing.use_case.catch_up": "☕ поболтать",
  "home.marketing.use_case.jam_session": "🎸 джем-сейшн",
  "home.marketing.use_case.book_club": "📖 книжный клуб",
  "home.marketing.use_case.coworking": "💻 коворкинг",
  "ended.heading": "звонок завершен",
  "ended.left": "ты вышел из комнаты.",
  "ended.room_ended": "{title} завершился для тебя.",
  "ended.rejoin": "перезайти",
  "ended.rejoining": "перезаходим...",
  "ended.home": "на главную",
  "call.connecting": "подключаемся",
  "call.waiting": "ждем остальных",
  "call.invite_code": "код инвайта",
  "call.audio_on": "звук вкл",
  "call.muted": "в мьюте",
  "call.listening": "Слушает",
  "call.audio_muted": "Звук выключен",
  "call.speaking": "говорит",
  "call.you": "ты",
  "call.you_label": "Ты",
  "call.you_suffix": "(ты)",
  "call.chat_placeholder": "написать...",
  "call.guest": "гость",
  "call.room_fallback": "комната",
  "call.focus_view": "Фокус",
  "call.grid_view": "Сетка",
  "call.swap_main_video": "Сменить главное видео",
  "call.open_chat": "Открыть чат",
  "call.close_chat": "Закрыть чат",
  "call.leave_room": "Выйти из комнаты",
  "call.confirm_leave": "Выйти?",
  "call.mic_on": "Микро вкл",
  "call.muted_label": "В мьюте",
  "call.camera_off": "Камера выкл",
  "call.connect_failed": "Не удалось подключиться — чекни инет и попробуй еще раз.",
  "call.camera_access_failed": "Нет доступа к камере. Чекни разрешения браузера и попробуй снова.",
  "call.recording_failed": "Не удалось начать запись. Звонок продолжится без нее.",
  "call.initialize_failed": "Что-то пошло не так. Обнови страницу и попробуй еще раз.",
  "call.participants": "Участники",
  "call.open_participants": "Открыть участников",
  "call.close_participants": "Закрыть участников",
  "call.lock_room": "Закрыть комнату",
  "call.unlock_room": "Открыть комнату",
  "call.locked": "закрыто",
  "call.unlocked": "открыто",
  "call.kick_member": "Кикнуть из комнаты",
  "call.mute_member": "Замьютить",
  "call.unmute_member": "Размьютить",
  "call.muted_by_host": "Замьючен хостом",
  "call.waiting_to_join": "Ждут входа",
  "call.approve": "Впустить",
  "call.deny": "Отклонить",
  "call.profile_actions": "Действия с профилем",
  "call.profile_in_room": "В комнате",
  "call.profile_role_host": "Хост",
  "call.profile_role_you": "Ты",
  "call.profile_action_mute": "Замьютить звук",
  "call.profile_action_mute_meta": "Только для тебя — они не узнают",
  "call.profile_action_dm": "Личка",
  "call.profile_action_dm_meta": "Начать приватный чат",
  "call.profile_action_view": "Смотреть профиль",
  "call.profile_action_view_meta": "Био, языки, прошлые сессии",
  "call.profile_action_report": "Пожаловаться",
  "call.profile_action_report_meta": "Отправить модераторам",
  "call.profile_sheet_close": "Закрыть действия",
  "call.profile_open_actions": "Открыть действия",
  "call.dm_title": "Личные сообщения",
  "call.dm_back": "Назад к действиям",
  "call.dm_close": "Закрыть личку",
  "call.dm_status_online": "В сети",
  "call.dm_in_room_with": "В этой комнате",
  "call.dm_private_label": "Приватный чат",
  "call.dm_private_meta": "Эти сообщения видите только вы вдвоем",
  "call.dm_input_placeholder": "Написать в личку…",
  "call.dm_send": "Отправить",
  "call.dm_just_now": "сейчас",
  "call.dm_seen_just_now": "Прочитано только что",
  "call.dm_typing": "{name} печатает…",
  "call.dm_minimize": "Свернуть",
  "call.dm_active_indicator": "Открыть диалог",
  "call.dm_unread_messages": "{count} непрочитанных",
  "call.dm_toast_tap_to_open": "Нажми, чтобы открыть",
  "call.dm_reopen_aria": "Снова открыть диалог с {name}",
  "home.join_denied": "Хост тебя не впустил.",
  "home.error.room_not_found": "Такого кода комнаты нет.",
  "home.error.profile_required": "Заполни профиль, чтобы продолжить.",
  "home.cta.set_up_profile": "Настроить профиль",
  "home.profile_trigger_new": "Нажми, чтобы добавить инфу",
  "home.profile_trigger_new_aria": "Настроить профиль",
  "home.profile_trigger_edit_aria": "Редактировать профиль",
  "profile.eyebrow_new": "скажи привет",
  "profile.eyebrow_edit": "твой профиль",
  "profile.title_new": "Сделай по-своему.",
  "profile.title_edit": "Редактировать профиль",
  "profile.subtitle": "Пара деталей, чтобы другие знали, с кем общаются.",
  "profile.add_photo": "Добавить фото",
  "profile.add_photo_soon": "фото скоро будут",
  "profile.photo_empty": "нажми, чтобы добавить фото",
  "profile.photo_ready": "фото готово",
  "profile.photo_save_first": "сначала сохрани профиль, потом грузи фото",
  "profile.photo_crop_caption": "кадрируй фото",
  "profile.photo_auto_caption": "двигай и зумь, а мы сохраним автоматом",
  "profile.photo_upload": "Загрузить фото",
  "profile.photo_replace": "Заменить фото",
  "profile.photo_remove": "Удалить фото",
  "profile.photo_cancel": "Отмена",
  "profile.photo_save": "Сохранить фото",
  "profile.photo_uploading": "Грузим фото…",
  "profile.photo_removing": "Удаляем фото…",
  "profile.photo_choose_another": "Выбрать другое",
  "profile.photo_drag_hint": "Перетащи фото в круг. Изменения сохранятся сами.",
  "profile.photo_zoom": "Зум",
  "profile.photo_horizontal": "По горизонтали",
  "profile.photo_vertical": "По вертикали",
  "profile.name_label": "Имя",
  "profile.name_placeholder": "Как тебя называть?",
  "profile.gender_label": "Я",
  "profile.gender.woman": "Девушка",
  "profile.gender.man": "Парень",
  "profile.gender.unspecified": "Не указывать",
  "profile.bio_label": "О себе",
  "profile.bio_optional": "необязательно",
  "profile.bio_placeholder": "Языки, интересы, да что угодно…",
  "profile.cta_new": "Погнали",
  "profile.cta_edit": "Сохранить",
  "profile.saving": "Сохраняем…",
  "profile.close": "Закрыть",
  "profile.error.save_failed": "Не вышло сохранить профиль. Попробуй еще раз.",
  "profile.error.avatar_invalid_type": "Выбери картинку в PNG, JPEG, GIF или WebP.",
  "profile.error.avatar_too_large": "Выбери картинку до 5 МБ.",
  "profile.error.avatar_too_small": "Выбери картинку хотя бы 96x96 пикселей.",
  "profile.error.avatar_load_failed": "Не смогли прочитать картинку. Попробуй другой файл.",
  "profile.error.avatar_failed": "Не вышло загрузить фото. Попробуй еще раз.",
  "profile.error.avatar_remove_failed": "Не вышло удалить фото. Попробуй еще раз.",
  "effects.title": "Эффекты",
  "effects.soft": "Софт-фокус",
  "effects.vignette": "Виньетка",
  "effects.face": "Блюр лица",
  "effects.face_preview_only": "Блюр лица (только превью)",
  "effects.face_viewer_side": "Блюр лица (у зрителей)",
  "effects.face_strength": "Сила блюра",
  "effects.grade.off": "ВЫКЛ",
  "effects.grade.pop": "ЯРКО",
  "effects.grade.warm": "ТЕПЛО",
  "effects.grade.cool": "ХОЛОД",
  "effects.grade.bw": "ЧБ",
  "camera.off": "камера выкл",
  "camera.check": "чекни камеру",
  "camera.retry": "попробовать еще раз",
  "camera.ready": "камера готова",
  "camera.idle.title": "Включи камеру",
  "camera.idle.hint": "Запросим доступ у браузера, когда будешь готов.",
  "camera.idle.button": "Включить камеру",
  "camera.status.idle": "Ждем тебя",
  "camera.status.off": "Камера выключена",
  "camera.status.loading": "Просим доступ к камере...",
  "camera.status.denied": "Разреши доступ к камере в браузере и попробуй снова.",
  "camera.status.error": "Превью камеры отвалилось. Попробуй еще раз.",
  "camera.status.unsupported": "Этот браузер не поддерживает доступ к камере.",
  "camera.status.insecure": "Для камеры нужен HTTPS или localhost.",
  "camera.status.attach_failed": "Не удалось запустить превью камеры. Попробуй еще раз.",
  "camera.guest_name_placeholder": "Имя гостя",
  "camera.flip": "Сменить камеру",
  "camera.save_name": "Сохранить",
  "camera.edit_name": "Изменить имя",
  "mic.on": "Выключить микро",
  "mic.off": "Включить микро",
  "video.on": "Выключить камеру",
  "video.off": "Включить камеру",
  "chat.title": "чат",
  "chat.close": "Закрыть чат",
  "chat.loading": "грузим...",
  "chat.load_earlier": "загрузить старые",
  "chat.empty": "пока нет сообщений",
  "chat.send_error": "Сообщение не ушло — попробуй еще раз.",
  "chat.input_placeholder": "напиши сообщение...",
  "room.host": "Хост",
  "app.room_default_title": "Создать комнату",
  "app.chat_connection_rejected": "Чат не подключился — попробуй обновить.",
  "app.copy_failed": "Не вышло скопировать ссылку. Попробуй выделить и скопировать вручную.",
  "app.chat_not_connected": "Чат еще не подключился. Подожди секунду и попробуй снова.",
  "footer.terms": "Условия использования",
  "footer.copyright": "© 2026 Yano.AI"
}
